import { ResponseError } from '@marketplace-web/shared/api-client'
import { api } from 'data/api/api'

import { getCreateComplaintArgs } from '../transformers/complaint-creation'
import { CreateComplaintArgs, SubmitComplaintResp } from '../types/complaint-creation'

export const createComplaint = (args: CreateComplaintArgs) =>
  api.post<SubmitComplaintResp, ResponseError>('/complaints', getCreateComplaintArgs(args))
